"use client";
import { isGitHubUrl as i } from "./utils/misc.js";
const l = (e) => {
  let t = "LuBookOpen";
  return e.type === "documentation" && e.contentType === "book" ? t = "IoBookOutline" : e.type === "documentation" && e.contentType === "pdf" ? t = "FaFilePdf" : e.type === "github_issue" || i(e.url) ? t = "FaGithub" : e.type === "documentation" && e.contentType === "site" ? t = "LuGlobe" : e.type === "discourse" ? t = "FaDiscourse" : e.type === "discord" ? t = "FaDiscord" : e.type === "slack_message" ? t = "FaSlack" : e.type === "stackoverflow" && (t = "FaStackOverflow"), { builtIn: t };
};
export {
  l as getIcon
};
